import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_STS_ALERT_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getStsAlertReferenceData = createAsyncThunk(
  'stop/getstsAlertReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(EPISODE_STS_ALERT_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const stsAlertReferenceSlice = createSlice({
  name: 'stop/stsAlertReference',
  initialState: null,
  reducers: {
    resetStsAlertReference: () => null,
  },
  extraReducers: {
    [getStsAlertReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetStsAlertReference } = stsAlertReferenceSlice.actions;

export default stsAlertReferenceSlice.reducer;
